/*
  商品LPの動き。ベンチマーク（ていねい通販「高麗美人」）が js-scroll-animation で
  やっているのと同じ考え方で、スクロールで入ってきた要素をふわっと出す。

  設計メモ
  - 初期状態(opacity:0)はJSが <html> に .lp-motion を付けてから効くようにしてある。
    JSが落ちても本文が消えないようにするため。
  - 端末が「動きを減らす」設定なら何もしない。
  - 一度出たら監視を外す。戻るたびに再生すると読みにくいので繰り返さない。
*/
(function () {
  var root = document.documentElement;

  // 動きを減らす設定なら、初期状態も付けずに素通しする
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  // 出す対象。全部動かすとうるさいので、見出し・カード・イラストに絞る
  var TARGETS = [
    '.st-seimei-hero__title', '.st-seimei-hero__sub',
    '.st-seimei-intro__rec', '.st-seimei-intro__staff',
    '.st-seimei-ingredient__h', '.st-seimei-toyo__title', '.st-seimei-toyo__panel',
    '.st-seimei-nutrient__title', '.st-seimei-nutrient__bubble',
    '.st-seimei-material__card', '.st-seimei-compare__table',
    '.st-seimei-spec__badge',
    '.st-story__head', '.st-story__block', '.st-story__bubble',
    '.st-steps__title', '.st-steps__item',
    '.st-seimei-hint__title', '.st-seimei-hint__card',
    '.st-subinfo__title', '.st-subinfo__card', '.st-subinfo__step', '.st-subinfo__cancel',
    '.st-seimei-voice__card', '.st-seimei-faq__item',
    '.st-nar__act',
    '.st-seimei-band__title', '.st-seimei-band__visual',
    '.st-seimei-price__pill', '.st-seimei-price__card'
  ].join(',');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(TARGETS));
    if (!nodes.length) return;

    root.classList.add('lp-motion');

    // 同じ親に並ぶものは少しずつ遅らせて、順に出てくるように見せる
    var seen = new Map();
    nodes.forEach(function (el) {
      var p = el.parentNode;
      var i = seen.get(p) || 0;
      seen.set(p, i + 1);
      el.setAttribute('data-reveal', '');
      if (i > 0) el.style.setProperty('--reveal-delay', Math.min(i, 5) * 70 + 'ms');
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, {
      // 少し手前で出し始める。画面に入りきってからだと遅れて見える
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08
    });

    nodes.forEach(function (el) {
      // 初回表示ですでに画面内にあるものは、待たずに出す
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  });
})();
